import React, { useState, useEffect } from 'react'
import { Helmet } from 'react-helmet'
import { useSelector, useDispatch } from 'react-redux'
import { Routes, Route, useLocation } from 'react-router-dom'
import { capitalize } from '../../../helpers'
import { getAllActivity } from '../../../store/actions'
import TopNav from './TopNav'
import SideNav from './SideNav'
import DashContent from './DashContent'
import { Orders, Admins, Companies, Bikes, AuditLogs, Zones } from '../'
import Container from './styles'

const AdminDashboard = () => {
  const dispatch = useDispatch()
  const { userData } = useSelector((s) => s.UserData)
  const [showNav, setDisplay] = useState(false)
  const { pathname } = useLocation()
  const titleTxt = `Dashboard
    ${
      pathname.split('/') && pathname.split('/')[2]
        ? `| ${capitalize(pathname.split('/')[2])}`
        : ''
    }`

  useEffect(() => {
    setDisplay(false)
  }, [pathname])

  useEffect(() => {
    dispatch(getAllActivity({}))
  }, [dispatch])

  return (
    <>
      <Helmet>
        <title>{titleTxt}</title>
      </Helmet>
      <Container>
        <aside
          className={`sideNav--container ${showNav ? 'show--nav__mobile' : ''}`}
        >
          <SideNav {...{ showNav: () => setDisplay(!showNav) }} />
        </aside>
        <div className="dashboard--content">
          <TopNav {...{ userData, showNav: () => setDisplay(!showNav) }} />
          <div className="dashboard--content__container">
            <Routes>
              <Route path="/" element={<DashContent />} />
              <Route path="/admins/*" element={<Admins />} />
              <Route path="/companies/*" element={<Companies />} />
              <Route path="/orders/*" element={<Orders />} />
              <Route path="/audit-logs" element={<AuditLogs />} />
              <Route path="/zone/*" element={<Zones />} />
              <Route path="/bikes/*" element={<Bikes />} />
            </Routes>
          </div>
        </div>
      </Container>
    </>
  )
}

export default AdminDashboard
